import { render } from "./EventDetails.vue?vue&type=template&id=1dc6a622"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\erwin\\Dropbox\\My Projects\\JavaScript\\Vue\\vuemastery\\real-world-vue-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__